import './bootstrap';

import { createApp } from 'vue';
import { i18nVue } from 'laravel-vue-i18n';

import App from './App.vue'
import router from './Router';
import store from "./Store";

import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask';
import DatePicker from 'vue-datepicker-next';
import PrimeVue from 'primevue/config';
// import moment from 'moment';

import 'vue-datepicker-next/index.css';


import 'sweetalert2/dist/sweetalert2.min.css';
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "vue3-toastify/dist/index.css";


const app = createApp(App)
    .use(i18nVue)
    .use(store)
    .use(router)
    .use(VueSweetalert2)
    .use(VueTheMask)
    .use(PrimeVue)
    .use(DatePicker);

app.config.globalProperties.$business_id = 1

app.config.globalProperties.$slugify = function (text) {
  return text.trim().toLowerCase().replace(/\s+/g, '-');
};

app.config.globalProperties.$br_price = function (price) {
  if(price){
    return parseFloat(price).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  }
};


app.config.globalProperties.$checkIsMobile = function () {
  return window.innerWidth <= 768;
};  

app.config.globalProperties.$formatDate = function (dateTimeString) {
  const date = new Date(dateTimeString);
      // Obtém os componentes de data (dia, mês, ano)
      const day = date.getDate();
      const month = date.getMonth() + 1; // Mês é base 0, então somamos 1
      const year = date.getFullYear();
      // Formata a data no formato desejado (DD/MM/YYYY)
      return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
};




// app.component('formatarData', {
//     filters: {
//         formatarData: function (data, formato) {
//         return moment(data).format(formato);
//         }
//     }
// });



app.mount("#app");
